import React, { useEffect, useState, useCallback } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import * as _ from 'lodash';
import { BiSort } from 'react-icons/bi';
import { roundOfDigit } from 'components/common/utils';
import SearchBox from 'components/general/SearchBox';
import { PAYMENT_STATUS_REPORT, DOWNLOAD_PAYMENT_STATUS_REPORT } from 'actions/dataReport';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { IoSearchOutline } from 'react-icons/io5';
import { BsDownload } from 'react-icons/bs';
import DateTimePicker from 'components/inputs/DateTimePicker';
import fileDownload from 'js-file-download';
import { MdClear } from 'react-icons/md';
import { Form, Formik } from 'formik';
import Select from 'components/inputs/Select';
import OffCanvas from 'components/inputs/OffCanvas';
import ReactPagination from 'components/general/ReactPagination';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { FaFilter } from 'react-icons/fa';
import Footer from 'components/general/Footer';

const PaymentStatusReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  // const [allpaymentStatusReportData, setAllpaymentStatusReportData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf('month'));
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));
  const [changePaymentGateway, setChangePaymentGateway] = useState(false);
  const [changePaymentStatus, setChangePaymentStatus] = useState(false);
  const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
  const [advanceFilterData, setAdvanceFilterData] = useState({});

  const paymentStatusList = useSelector((state) => state.paymentStatusReport.paymentStatusReports);
  const isLoader = useSelector((state) => state.paymentStatusReport.isLoading);
  const page = useSelector((state) => state.paymentStatusReport.page);
  const totalData = useSelector((state) => state.paymentStatusReport.total);
  const limit = useSelector((state) => state.paymentStatusReport.limit);
  const totalPages = useSelector((state) => state.paymentStatusReport.totalPages);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
  const profileData = useSelector((state) => state.profile.userProfile);
  const currentUserName = _.get(profileData, 'name', '');

  const paymentStatusReport = useCallback(
    (value) => {
      if (searchText) {
        const paymentStatusReportData = {
          ...value,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          search: searchText,
        };
        dispatch({
          type: PAYMENT_STATUS_REPORT.REQUEST,
          payload: paymentStatusReportData,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else {
        const data = {
          ...value,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        dispatch({
          type: PAYMENT_STATUS_REPORT.REQUEST,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      }
    },
    [startDate, endDate, searchText]
  );

  const getSortByItem = useCallback(
    (name, order, page, filterDateData) => {
      const sortedOrder = order || 'asc';
      if (page && startDate && endDate) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
        };
        endDate && paymentStatusReport(data);
      } else if (page) {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
        };
        paymentStatusReport(data);
      } else if (filterDateData) {
        const data = {
          ...filterDateData,
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        };
        endDate && paymentStatusReport(data);
      } else {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        };
        paymentStatusReport(data);
      }
    },
    [startDate, endDate]
  );

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else if (advanceFilterData) {
      if (advanceFilterData.method === 'All' && advanceFilterData.status === 'All') {
        const filterData = { ...advanceFilterData, method: '', status: '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        paymentStatusReport(data);
      } else if (advanceFilterData.method === 'All') {
        const filterData = { ...advanceFilterData, method: '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        paymentStatusReport(data);
      } else if (advanceFilterData.status === 'All') {
        const filterData = { ...advanceFilterData, status: '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        paymentStatusReport(data);
      } else {
        const data = {
          ...advanceFilterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        paymentStatusReport(data);
      }
    } else {
      const filterDateData = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
      };
      paymentStatusReport(filterDateData);
    }
  }, [startDate, endDate, sortByItem, advanceFilterData, searchText]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (advanceFilterData) {
        if (advanceFilterData.method === 'All' && advanceFilterData.status === 'All') {
          const filterData = { ...advanceFilterData, method: '', status: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          paymentStatusReport(data);
        } else if (advanceFilterData.method === 'All') {
          const filterData = { ...advanceFilterData, method: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          paymentStatusReport(data);
        } else if (advanceFilterData.status === 'All') {
          const filterData = { ...advanceFilterData, status: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          paymentStatusReport(data);
        } else {
          const data = {
            ...advanceFilterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          paymentStatusReport(data);
        }
      } else if (startDate && endDate && searchText) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          search: searchText,
          page: page.selected + 1,
        };
        paymentStatusReport(data);
      } else if (startDate && endDate) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          page: page.selected + 1,
        };
        paymentStatusReport(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        paymentStatusReport(data);
      }
    },
    [sortByItem, startDate, endDate, advanceFilterData, searchText]
  );

  useEffect(() => {
    paymentStatusReport();
  }, []);

  // useEffect(() => {
  //   setAllpaymentStatusReportData(
  //     _.filter(
  //       paymentStatusList,
  //       (item) =>
  //         startsWith(_.get(item, 'details.status'), searchText) ||
  //         startsWith(_.get(item, 'details.amount').toString(), searchText) ||
  //         startsWith(_.get(item, 'details.currency'), searchText) ||
  //         startsWith(_.get(item, 'details.created_at').toString(), searchText) ||
  //         startsWith(_.get(item, 'transaction_id'), searchText) ||
  //         startsWith(_.get(item, 'details.email'), searchText) ||
  //         startsWith(_.get(item, 'details.contact'), searchText) ||
  //         startsWith(_.get(item, 'details.order_id'), searchText) ||
  //         startsWith(_.get(item, 'details.method'), searchText) ||
  //         startsWith(_.get(item, 'details.bank'), searchText) ||
  //         startsWith(_.get(item, 'id'), searchText) ||
  //         startsWith(roundOfDigit(_.get(item, 'details.amount') / 100, 2).toString(), searchText) ||
  //         startsWith(moment(_.get(item, 'createdAt')).format('DD/MM/YYYY H:mm:ss'), searchText)
  //     )
  //   );
  // }, [searchText, paymentStatusList]);

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchText(value);
  };

  const handleSearch = () => {
    paymentStatusReport({});
  };

  // Download Excel Functionality

  const downloadpaymentStatusReport = useCallback(() => {
    if (advanceFilterData) {
      if (advanceFilterData.method === 'All' && advanceFilterData.status === 'All') {
        const filterData = { ...advanceFilterData, method: '', status: '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        dispatch({
          type: DOWNLOAD_PAYMENT_STATUS_REPORT.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Payment Status Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.method === 'All') {
        const filterData = { ...advanceFilterData, method: '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        dispatch({
          type: DOWNLOAD_PAYMENT_STATUS_REPORT.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Payment Status Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.status === 'All') {
        const filterData = { ...advanceFilterData, status: '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        dispatch({
          type: DOWNLOAD_PAYMENT_STATUS_REPORT.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Payment Status Report'}.xlsx`);
              }
            }
          },
        });
      } else {
        const data = {
          ...advanceFilterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        dispatch({
          type: DOWNLOAD_PAYMENT_STATUS_REPORT.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Payment Status Report'}.xlsx`);
              }
            }
          },
        });
      }
    } else {
      const data = {
        excel: true,
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
      };
      dispatch({
        type: DOWNLOAD_PAYMENT_STATUS_REPORT.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              fileDownload(res.data, `${'Payment Status Report'}.xlsx`);
            }
          }
        },
      });
    }
  }, [startDate, endDate, advanceFilterData]);

  const downloadFile = () => {
    downloadpaymentStatusReport();
  };

  const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);

  const search = (
    <SearchBox
      preIcon={<BsSearch />}
      value={searchText}
      onChange={searchHandler}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          handleSearch();
        }
      }}
    />
  );
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;
  const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);

  const initialValues = !_.isEmpty(advanceFilterData) ? { ...advanceFilterData } : { method: '', status: '' };

  //   const allPaymentMethod = [
  //     { label: 'Net banking', value: 'netbanking' },
  //     { label: 'Card', value: 'card' },
  //     { label: 'Wallet', value: 'wallet' },
  //     { label: 'UPI', value: 'upi' },
  //   ];

  const allPaymentStatus = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Failed', value: 'Failed' },
    { label: 'Pending', value: 'Pending' },
  ];

  const allPaymentGateway = [
    { label: 'BillDesk (Kotak Bank)', value: 'Kotak' },
    { label: 'ICICI BANK', value: 'ICICI' },
    { label: 'HDFC BANK', value: 'HDFC' },
  ];

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.paymentStatusReport')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="data-report--main">
              <Card>
                <div className="data-report__inner">
                  <div className="data-report__box">
                    <Row className="data-report__row">
                      <Col
                        xl={`${showSearchBar ? 'auto' : 'auto'}`}
                        md={`${showSearchBar ? 'auto' : 'auto'}`}
                        className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                      >
                        {showSearchBar ? search : searchIcon}
                      </Col>
                      <Col xl={`${showSearchBar ? 'auto' : 'auto'}`} md={`${showSearchBar ? 'auto' : 'auto'}`}>
                        <div className="data-report-date_picker">
                          <DateTimePicker
                            onChangeOfStartDate={(item) => setStartDate(item)}
                            onChangeOfEndDate={(item) => setEndDate(item)}
                            initialValueOfStartDate={moment().startOf('month')}
                            initialValueOfEndDate={moment(new Date()).endOf('day')}
                          />
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="report-search-box" onClick={dateFilter}>
                          <Button className="report-search-button">{t('button.search')}</Button>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="report-search-excel-block">
                          <div className="advance-filter-btn" onClick={() => setShowAdvanceFilterPopup(true)}>
                            <Button className="report-search-button">
                              <FaFilter className="hide-lap" />
                              <span>{t('button.advancedFilter')}</span>
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
                        {isLoading ? (
                          <div className="loader--block">
                            <Spinner as="span" animation="border" size="sm" role="status" />
                          </div>
                        ) : (
                          <div className="report-excel-icon">
                            <BsDownload title="Download" size={28} color={'#3c7cdd'} />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="data-report__table">
                    <div className="table-responsive">
                      <table className="record-list-table" id="table-to-xls">
                        <thead>
                          <tr>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.srNo')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.invoiceId')}</span>
                                <span className="ico" onClick={() => handleSorting('id', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.transactionId')}</span>
                                <span className="ico" onClick={() => handleSorting('transaction_id', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.paymentGateway')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.userName')}</span>
                                <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.userMobileNo')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.customerId')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.paymentUniqueIdentity')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.paymentStatus')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.amount')}</span>
                                <span className="ico" onClick={() => handleSorting('amount', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.transactionDateTime')}</span>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoader ? (
                            <tr>
                              <td colSpan={12} className="border-0">
                                <div className="loader--block">
                                  <Skeleton height={15} width={100} />
                                </div>
                              </td>
                            </tr>
                          ) : _.isEmpty(paymentStatusList) ? (
                            <tr>
                              <td colSpan={10} className="border-0">
                                <div className="empty-data-block">{t('dataReport.noPaymentStatusData')}</div>
                              </td>
                            </tr>
                          ) : (
                            !(isLoader || _.isUndefined(isLoader)) &&
                            _.map(
                              _.filter(paymentStatusList, (item) => item !== null),
                              (item, key) => {
                                const serial_num = limit * (page - 1) + key;

                                const fromDate = moment(item.createdAt, 'YYYY-MM-DD');
                                const targetDate = moment('2023-05-04', 'YYYY-MM-DD');
                                const isAfter = fromDate.isAfter(targetDate);
                                let gateway = '-';
                                if (item?.gatewayId === '2') {
                                  gateway = 'ICICI';
                                } else if (isAfter) {
                                  gateway = 'Billdesk';
                                } else if (item?.gatewayId === '1') {
                                  gateway = 'Billdesk';
                                } else {
                                  gateway = '-';
                                }

                                return (
                                  <>
                                    <tr key={`payment-status-report-${serial_num}`}>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : serial_num + 1}</td>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'id', '-')}</td>
                                      <td>
                                        {isLoader ? (
                                          <Skeleton height={15} width={100} />
                                        ) : (
                                          (item?.payment?.transaction_id ?? item?.response_snapshot?.data?.PTxnId ?? '-')
                                        )}
                                      </td>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : gateway}</td>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'user.name', 'Guest User')}</td>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'user.phone', '-')}</td>
                                      <td>
                                        {isLoader ? (
                                          <Skeleton height={15} width={100} />
                                        ) : (
                                          (item?.payment?.details?.CustomerId ?? item?.response_snapshot?.data?.CustomerId ?? '-')
                                        )}
                                      </td>
                                      <td>
                                        {isLoader ? (
                                          <Skeleton height={15} width={100} />
                                        ) : (
                                          (item?.payment?.details?.PaymentUniqIdentity ?? item?.response_snapshot?.data?.PaymentUniqIdentity ?? '-')
                                        )}
                                      </td>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'status', '')}</td>
                                      <td>{isLoader ? <Skeleton height={15} width={100} /> : roundOfDigit(_.get(item, 'amount', '-'), 2)}</td>
                                      <td>
                                        {isLoader ? (
                                          <Skeleton height={15} width={100} />
                                        ) : item.createdAt ? (
                                          moment(item.createdAt).format('DD/MM/YYYY H:mm:ss')
                                        ) : (
                                          '-'
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(paymentStatusList) && (
                    <ReactPagination
                      currentPage={page}
                      limit={limit}
                      total={totalData}
                      handlePageClick={(pageVal) => handlePageClick(pageVal)}
                      totalPages={totalPages}
                      marginPagesDisplayed={1}
                    />
                  )}
                </div>
              </Card>
            </div>
          </div>
        </SkeletonTheme>
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>

      {/* Report Advance Filter Functionality */}

      {showAdvanceFilterPopup && (
        <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
          <Formik
            enableReinitialize={!_.isEmpty(advanceFilterData)}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              !values.method && delete values['method'];
              !values.status && delete values['status'];
              !values.gateway && delete values['gateway'];
              if (values.method === 'All' && values.status === 'All' && values.gateway === 'All') {
                const paymentStatusReportData = { ...values, method: '', status: '', gateway: '' };
                paymentStatusReport(paymentStatusReportData);
              } else if (values.method === 'All' && values.status === 'All') {
                const paymentStatusReportData = { ...values, method: '', status: '' };
                paymentStatusReport(paymentStatusReportData);
              } else if ((values.status === 'All', values.gateway === 'All')) {
                const paymentStatusReportData = { ...values, status: '', gateway: '' };
                paymentStatusReport(paymentStatusReportData);
              } else if (values.method === 'All') {
                const paymentStatusReportData = { ...values, method: '' };
                paymentStatusReport(paymentStatusReportData);
              } else if (values.status === 'All') {
                const paymentStatusReportData = { ...values, status: '' };
                paymentStatusReport(paymentStatusReportData);
              } else if (values.gateway === 'All') {
                const paymentStatusReportData = { ...values, gateway: '' };
                paymentStatusReport(paymentStatusReportData);
              } else {
                paymentStatusReport(values);
              }
              handleAdvanceFilterData(values);
              setSubmitting(false);
            }}
          >
            {({ values, handleSubmit, setFieldValue, resetForm }) => (
              <Form onSubmit={handleSubmit}>
                <div className="mb-5">
                  <Select
                    label={t('dataReport.paymentGateway')}
                    options={
                      !changePaymentGateway
                        ? !_.isEmpty(allPaymentGateway) && [
                            { label: 'All', value: 'All' },
                            ..._.map(allPaymentGateway, (item) => {
                              return { label: item.label, value: item.value };
                            }),
                          ]
                        : !_.isEmpty(allPaymentGateway) && [{ label: 'All', value: 'All' }]
                    }
                    placeholder={t('placeHolder.selectPaymentGateway')}
                    name="gateway"
                    isMulti
                    value={values.gateway}
                    onChange={(val) => {
                      if (_.includes(val, 'All')) {
                        setChangePaymentGateway(true);
                        setFieldValue(`gateway`, 'All');
                      } else if (_.isEmpty(val)) {
                        setFieldValue(`gateway`, '');
                        setChangePaymentGateway(false);
                      } else {
                        setChangePaymentGateway(false);
                        setFieldValue('gateway', val);
                      }
                    }}
                  />
                  <div className="canvas-selection__block">
                    <Select
                      label={t('dataReport.paymentStatus')}
                      options={
                        !changePaymentStatus
                          ? !_.isEmpty(allPaymentStatus) && [
                              { label: 'All', value: 'All' },
                              ..._.map(allPaymentStatus, (item) => {
                                return { label: item.label, value: item.value };
                              }),
                            ]
                          : !_.isEmpty(allPaymentStatus) && [{ label: 'All', value: 'All' }]
                      }
                      placeholder={t('placeHolder.selectPaymentStatus')}
                      name="status"
                      isMulti
                      value={values.status}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        if (_.includes(val, 'All')) {
                          setChangePaymentStatus(true);
                          setFieldValue(`status`, 'All');
                        } else if (_.isEmpty(val)) {
                          setFieldValue(`status`, '');
                          setChangePaymentStatus(false);
                        } else {
                          setChangePaymentStatus(false);
                          setFieldValue('status', val);
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="canvas-btn__block">
                  <Button type="submit" className="apply--btn w-100">
                    {t('button.applyFilters')}
                  </Button>
                  <div
                    className="reset--block"
                    onClick={() => {
                      setAdvanceFilterData({});
                      paymentStatusReport();
                      resetForm();
                      onCloseAdvanceFilterPopup();
                    }}
                  >
                    <MdClear size={24} className="reset--icon" />
                    {t('button.clear')}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </OffCanvas>
      )}
    </>
  );
};

export default PaymentStatusReport;
